module.exports = __webpack_public_path__ + "static/media/profileimage.99c2bee7.jpg";